var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spark 109",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.901 5.63854C14.5737 4.71014 14.4928 3.40271 13.6583 2.56801C12.7557 1.66516 11.3081 1.63961 10.3757 2.49561V2.37636C10.3757 1.06468 9.31134 0 8 0C6.68866 0 5.62427 1.06468 5.62427 2.37636V2.49561C4.69186 1.64386 3.24428 1.66516 2.34167 2.56801C1.50293 3.40697 1.42203 4.71014 2.09899 5.63854C0.919638 5.77482 0 6.77988 0 7.99787C0 9.30956 1.0644 10.3742 2.37573 10.3742H2.49494L2.34593 10.5233C1.41778 11.4517 1.41778 12.955 2.34593 13.8834C3.25279 14.7905 4.7174 14.8118 5.64556 13.9345C5.79883 15.0972 6.7951 16 8 16C9.2049 16 10.2012 15.1014 10.3544 13.9345C11.2869 14.8076 12.7472 14.7905 13.6541 13.8834C14.5822 12.955 14.5822 11.4517 13.6541 10.5233L13.5051 10.3742H13.6243C14.9356 10.3742 16 9.30956 16 7.99787C15.9957 6.77988 15.0804 5.77482 13.901 5.63854Z",
    fill: "#747474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkGray);
export default __webpack_public_path__ + "static/media/spark_gray.dbc6a58f0206fb0f0c646cafabea41f9.svg";
export { ForwardRef as ReactComponent };